
import { defineComponent, reactive, watch } from 'vue'
import ManagementLayout from '@/layout/ManagementLayout.vue'
import { News, usrState, usrPreviewState, updateResource } from '@/model'
import { useRoute } from 'vue-router'
import USRComponentListEditor from '@/components/USRComponentListEditor.vue'
import { addToArray, removeFromArray } from '@/utils'
import { ElLoading } from 'element-plus'
import api from '@/api'
import ImageUploader from '@/components/ImageUploader.vue'

interface State {
  editing: boolean;
  editingData: News;
}

export default defineComponent({
  name: 'ManageNewsPage',
  components: {
    USRComponentListEditor,
    ImageUploader,
  },
  created() {
    this.$emit('update:layout', ManagementLayout)
  },
  setup() {
    const route = useRoute()
    const pId = route.params.id as string
    const isNew = pId === 'new'

    const editingData = getEditingData()

    function getEditingData(): News {
      const emptyNews = {
        id: 0,
        time: new Date(),
        imgUrl: '',
        periods: '',
        periodsEn: '',
        title: '',
        titleEn: '',
        components: [],
        componentsEn: [],
        fbUrl: '',
        ytUrl: '',
        igUrl: '',
        webUrl: '',
      } as News

      return Object.assign(emptyNews, isNew ? {} : usrState.news.find(news => news.id === parseInt(pId, 10)))
    }

    const state = reactive({
      editing: false,
      editingData,
    }) as State

    watch(() => usrState.news, () => {
      console.log('updated!')
      state.editingData = getEditingData()
    })

    const cancel = () => {
      state.editingData = getEditingData()
    }

    const save = () => {
      const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      api.updateNews(state.editingData)
        .then(() => updateResource())
        .then(() => loading.close())
        .catch(() => loading.close())
    }

    const preview = () => {
      usrPreviewState.news = JSON.parse(JSON.stringify(state.editingData))
      localStorage.setItem('resourcesPreview', JSON.stringify(usrPreviewState))
      window.open('/news/Preview', '_blank')
    }

    const previewEn = () => {
      usrPreviewState.news = JSON.parse(JSON.stringify(state.editingData))
      localStorage.setItem('resourcesPreview', JSON.stringify(usrPreviewState))
      window.open('/news/Preview?lang=en', '__blank')
    }

    const handleUpload = (promise: Promise<void>) => {
      const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      promise
        .then(() => loading.close())
        .catch(() => loading.close())
    }

    return {
      isNew,
      state,
      addToArray,
      removeFromArray,
      cancel,
      save,
      preview,
      previewEn,
      handleUpload,
    }
  },
})
